import { render } from "./IndexUser.vue?vue&type=template&id=25b5db50"
import script from "./IndexUser.vue?vue&type=script&lang=js"
export * from "./IndexUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__